import axios from "../axios";

const updateBalance = async function (accessToken,data = {}) {
    try {
        const response = await axios.post('partner/updateBalance', data ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default updateBalance;
